<template>
  <div class="section-hero sectionBackGround">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-2">
          <card class="border-0 text-left" hover shadow body-classes="py-3" style="margin-top: 20px;">
            <div class="row row-cols-2 row-cols-lg-5 g-2 g-lg-3">
              <div class="col-4 col-md-12">
                <label>会员中心</label>
              </div>
              <div class="col-4 col-md-12">
                <a class="nav-link" href="#/PersonalDataList?searchQuery=2"
                  style="height: 35px;">
                  <ul style="margin-left: -28px;">
                    <li> <label>个人资料</label></li>
                  </ul>
                </a>
              </div>
              <div class="col-4 col-md-12" style="background-color: #f0f0f0;">
                <a class="nav-link" href="" style="height: 35px; ">
                  <ul style="margin-left: -28px;">
                    <li> <label>我的收藏</label></li>
                  </ul>
                </a>
              </div>
              <div class="col-4 col-md-12">
  <a class="nav-link" href="#" @click.prevent="logout" style="height: 35px;">
                  <ul style="margin-left: -28px;">
                    <li> <label @click="logout" >退出登录</label></li>
                  </ul>
                </a>
              </div>
            </div>
          </card>

        </div>
        <div class="col-lg-10">
          <card style="margin-top: 20px;">
            <div class="btn-wrapper" style="position: relative;">
              <base-input
                style="border-radius: 4px; background: rgba(155, 165, 175, 0.10); color: #333; font-family: 'Noto Sans S Chinese';"
                v-model="searchQuery" @keyup.enter="search" alternative placeholder="二型糖尿病">
              </base-input>

              <i class="fa fa-search search-icon" @click="search"></i>
              <i class="fa fa-times search-icon" @click="search" style="margin-right: 30px;"></i>
            </div>
            <hr class="divider" />
            <div v-if="loading" class="text-center mt-5">
              <p>正在加载...</p>
            </div>

            <div v-else-if="searchResults.length === 0" class="text-center mt-5">
              <p>没有找到相关结果，请尝试其他关键词。</p>
            </div>

            <div v-else>
              <div v-for="result in paginatedResults" :key="result.id" class="mt-0">
                <a class="nav-link" @click.prevent="viewDocumentDetail(result.id)" href="#" style="margin-top: 0;">
                  <h6 class="text-uppercase"
                    style="color: #333; font-family: 'Noto Sans S Chinese'; font-size: 20px; font-weight: 500; line-height: 28px; letter-spacing: 1px;">
                    {{ result.articletitle }}
                  </h6>
                  <div>
                    <badge
                      style="color: #333; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">
                      <i class="fa fa-circle-o-notch" aria-hidden="true"></i> {{ result.articletags }}
                    </badge>
                    <badge
                      style="color: #333; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">
                      <i class="fa fa-star-o" aria-hidden="true"></i> 推荐评分 {{ result.recommendationscore }}
                    </badge>
                    <badge
                      style="color: #333; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">
                      <i class="fa fa-heart-o" aria-hidden="true"></i> 收藏
                    </badge>
                  </div>
                  <p class="description mt-2"
                    style="color: #333; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px; letter-spacing: 1px;">
                    {{ result.articleabstract.substring(0, 200) }}...
                  </p>
                </a>
              </div>
            </div>

            <div v-if="searchResults.length > 0 && totalPages > 1" class="pagination-controls mt-4 text-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li class="page-item disabled" tabindex="-1" @click="prevPage" :disabled="currentPage === 1">
                    <a class="page-link" href="#">
                      <i class="fa fa-angle-left"></i>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item active"><a class="page-link" href="#">{{ currentPage }}</a></li>
                  <li class="page-item"><a class="page-link" href="#">{{ currentPage + 1}}</a></li>
                  <li class="page-item"><a class="page-link" href="#">{{ currentPage + 2}}</a></li>
                  <li class="page-item" @click="nextPage" :disabled="currentPage === totalPages">
                    <a class="page-link" href="#">
                      <i class="fa fa-angle-right"></i>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <!-- <base-button @click="prevPage" :disabled="currentPage === 1" type="primary" class="mr-2">
                上一页
              </base-button>
              <span>{{ currentPage }} / {{ totalPages }}</span>
              <base-button @click="nextPage" :disabled="currentPage === totalPages" type="primary" class="ml-2">
                下一页
              </base-button> -->
            </div>
          </card>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "DocQueryList",
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      page: 1,
      totalDocuments: 0, // 确保初始化
      currentPage: 1,
      itemsPerPage: 10, // 默认每页10条
      loading: false,
      pagination: {
        default: 1
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalDocuments / this.itemsPerPage); // 通过总文档数计算总页数
    },
    paginatedResults() {
      return this.searchResults; // searchResults 已经是当前页面的数据，无需 slice
    }
  },
  watch: {
    // 监听路由参数 searchQuery 的变化并更新到本地的 searchQuery
    '$route.query.searchQuery': {
      immediate: true,  // 确保首次加载时立即执行
      handler(newQuery) {
        if (newQuery) {
          this.searchQuery = newQuery;  // 同步到 v-model
          this.search();  // 调用搜索方法
        }
      }
    }
  },

  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
	  clearCookie(name) {
	      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	    },
	    logout() {
	      // 清除 token 和 username 的 cookie
	      this.clearCookie('token');
	      this.clearCookie('username');
	      // 清除本地存储的用户名，确保界面更新
	      this.username = ''; // 清空保存的用户名
	      // 跳转到主页或登录页
	      this.$router.push('/'); // 跳转到主页
	      window.location.reload(); // 重新加载页面以更新状态
	 
	  },
    async search() {
     // console.log('当前搜索关键词:', this.searchQuery); // 调试输出
      const token = this.getCookie('token');
      if (!token) {
        alert('Token not found, please login');
        this.$router.push('/login');
        return;
      }


      if (this.searchQuery.trim() === '') {
        this.searchResults = [];
        return;
      }

      this.loading = true;
      try {
        const params = new URLSearchParams();
        params.append('keywords', this.searchQuery);

        params.append('token', token);
        params.append('page', this.currentPage); // 确保传递当前页
        params.append('itemsPerPage', this.itemsPerPage); // 传递每页条目数

        const response = await axios.post('https://anthromindxx.com/ca.php?action=search', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        if (response.data.success) {
          this.searchResults = response.data.posts; // 只保存当前页的数据
          this.totalDocuments = response.data.totalDocuments; // 保存总记录数
          this.itemsPerPage = response.data.itemsPerPage || this.itemsPerPage; // 确保 itemsPerPage 正确赋值

          // 不要在这里覆盖 this.currentPage
          // this.currentPage = response.data.currentPage;
        } else {
          this.searchResults = [];
        }


      } catch (error) {
        //console.error('Search failed:', error);
        this.searchResults = [];
      } finally {
        this.loading = false;
      }
    },
    // viewDocumentDetail(id) {
    //   sessionStorage.setItem('searchResults', JSON.stringify(this.searchResults));
    //   this.$router.push({
    //     name: "DocQueryListdetail",
    //     params: { id: id, searchResults: this.searchResults }
    //   });
    // },
    viewDocumentDetail(id) {
      sessionStorage.setItem('searchResults', JSON.stringify(this.searchResults));
      this.$router.push({
        path: '/DocQueryListdetail',
        query: { id: id, searchQuery: this.searchQuery, page: this.currentPage }
      });
    },


    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.search();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.search();
      }
    }
  },
  created() {
    const searchQuery = this.$route.query.searchQuery;
    const page = this.$route.query.page; // 获取页码参数

    //console.log('当前page:', page); // 调试输出

    if (searchQuery) {
      this.searchQuery = searchQuery; // 确保初始化
      if (page) {
        this.currentPage = page; // 恢复页码
      }

      this.search();  // 调用搜索方法



    } else {
      this.searchResults = [];
    }

    if (storedResults) {
      this.searchResults = JSON.parse(storedResults);
    } else if (this.$route.params.searchResults) {
      this.searchResults = this.$route.params.searchResults;
      this.totalDocuments = this.$route.params.totalDocuments || 0;
      this.itemsPerPage = this.$route.params.itemsPerPage || 10;
      this.currentPage = this.$route.params.currentPage || 1;
    } else {
      this.searchResults = [];
      this.totalDocuments = 0;
      this.itemsPerPage = 10;
      this.currentPage = 1;
      this.search(); // 调用 search 方法进行搜索
      // 在组件创建时调用 search 方法

    }
    if (!Array.isArray(this.searchResults)) {
      this.searchResults = [];
    }
  }
};
</script>

<style scoped>
.sectionBackGround {
  /* 使内容区域填充剩余空间 */
  min-height: calc(100vh - 48px);
  /* 确保内容区域至少与视口高度减去头部高度一样大 */
  background-image: url('https://anthromindxx.com/ant/bj.jpeg');
  /* 设置背景图路径 */
  background-position: center center;
  /* 背景图片位置 */
  background-attachment: fixed;
  /* 背景图片相对于视口固定 */
  background-size: 100% 100%;
  /* 背景图片根据元素大小缩放 */
  overflow-y: auto;
  /* 在内容较多时显示滚动条 */
  overflow: auto;
}

/* 当屏幕尺寸小于某个值时，为元素添加滚动条 */
@media (max-width: 600px) {
  .sectionBackGround {
    height: 300px;
    /* 设置一个固定高度或者最大高度 */
    overflow-y: scroll;
    /* 仅在垂直方向上显示滚动条 */
  }
}

.search-icon {
  color: #0ff5c8;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}


.pagination-controls {
  margin-top: 20px;
  margin-bottom: 20px;
}


.divider {
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin-top: 5px;
}

.div1 {
  align-self: stretch;
  position: relative;
  letter-spacing: 2px;
  line-height: 20px;
}

.child {
  width: 600px;
  position: relative;
  height: 4px;
}

.div {
  width: 100%;
  position: relative;
  height: 65px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  text-align: left;
  font-size: 14px;
  color: rgba(51, 51, 51, 0.6);
  font-family: 'Noto Sans S Chinese';
}
</style>